import { ReactNode } from "react";
import { C } from "./designTokens";

interface LabelProps {
  children: ReactNode;
  light?: boolean;
}

export default function Label({ children, light = false }: LabelProps) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "2px",
          background: light ? C.coral : C.navy,
          borderRadius: "1px",
        }}
      />
      <span
        style={{
          fontFamily: C.mono,
          fontSize: "11px",
          letterSpacing: "0.15em",
          textTransform: "uppercase",
          color: light ? C.coral : C.gray500,
          fontWeight: 500,
        }}
      >
        {children}
      </span>
    </div>
  );
}
